var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex_center sc_box" }, [
    _c("div", { staticClass: "flex_start" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "right_box flex_space flex_center flex_center_align" },
        [
          _c(
            "span",
            {
              staticClass: "move_left word flex_center_align",
              on: {
                click: function ($event) {
                  return _vm.scroll("left")
                },
              },
            },
            [_vm._v(" 一番左へ移動 ")]
          ),
          _c("div", { staticClass: "move_center flex_space" }, [
            _c(
              "div",
              {
                staticClass: "icon_box flex_center_align flex_center",
                on: {
                  click: function ($event) {
                    return _vm.scroll("sleft")
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "icon",
                  attrs: { src: require("@/assets/images/sc_icon2.png") },
                }),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "icon_box flex_center_align flex_center",
                on: {
                  click: function ($event) {
                    return _vm.scroll("sright")
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "icon",
                  attrs: { src: require("@/assets/images/sc_icon3.png") },
                }),
              ]
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "move_right word flex_center_align",
              on: {
                click: function ($event) {
                  return _vm.scroll("right")
                },
              },
            },
            [_vm._v(" 一番右へ移動 ")]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "left_box flex_colum flex_center_align flex_center" },
      [
        _c("img", {
          staticClass: "icon",
          attrs: { src: require("@/assets/images/sc_icon1.png") },
        }),
        _c("span", { staticClass: "word sub" }, [_vm._v("横スクロール")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }